import $ from 'jquery';
import templateData from '../utility/getTemplateData';
import appStore from '../stores/AppStore';
import { normalizeNumber } from './formator'
import {
	isAmountGreaterThanZero
} from '../components/amount/amountUtils';

let _addShake = () => {
	$('.inputField  .money_input').addClass('animated shake');
	setTimeout(() => {
		$('.inputField  .money_input').removeClass('animated shake');
	}, 1000);
};

let updateDonation = (redirecturl) => {
	const amount = appStore.getDonationAmount();
	let data = {
		token: templateData.token,
		amount: normalizeNumber(amount),
		donationAmountType: appStore.getDonationAmountType() === 'preset' ? 'preset' : 'userinput',
		currencyCode: templateData.donationCode,
		donationNote: appStore.getDonationNote() || '',
		recurring: appStore.getDonationRecurring(),
		addCardError: appStore.getAddCardError(),
		giftAidItFlag: appStore.getGiftaidItFlagStatus(),
	}

	$('.spinneroverlay').show()
	$.post('/donate/update/donation', data, function(result) {
		// console.log('DATA result', result);
		window.location.href = redirecturl;
	}).fail(function() {
		// On mayFly update failure, redirecting to landing page
		// Mayfly token will be re-validated and will handle following cases
		// Case 1: Display generic error page for expired token
		// Case 2: Start new flow, if token is valid.
		let failureUrl = '/donate?token=' + templateData.token;
		window.location.href = failureUrl;

		// $('.spinneroverlay').hide();
		// $('.err_update_amount').show()
	})
};


/*
 * Handles for loaging any CAL event.
 */
let logCalEvent = (message) => {
	$.post('/donate/event/logger', {
		message: message
	})
};

/*
 * Handles for redirect to UL.
 */
let handleLogIn = () => {

	let donationAmount = appStore.getDonationAmount()
	
	if (isAmountGreaterThanZero(donationAmount)) {

		updateDonation(`/donate/member?token=${templateData.token}`);

	} else {
		_addShake();
	}
};

/*
 * Handles for redirect to guest.
 */
let handleGuestCountryChange = (url) => {
	updateDonation(url);
};


/*
 * Handles if token is reused to access donate app to make second payment.
 */
let handleTokenReuse = () => {
	let paymentStatus = templateData.paymentStatus || '';
	if (paymentStatus === 'complete') {
		window.location.href = '/donate/paymentComplete';
	}
};

let handleGuest = (scope) => {

	let donationAmount = appStore.getDonationAmount();

	if (isAmountGreaterThanZero(donationAmount)) {

		scope.context.router.push(`/donate/guest?token=${templateData.token}`)

	} else {
		_addShake();
	}
};


let removeErrors = ($element) => {
	$element.parent().find('p.error').hide();
	$element.removeClass('error');
}


let serializeFormData = (obj) => {
	let o = {},
		a = obj.serializeArray();

	$.each(a, () => {
		if (o[this.name] !== undefined) {
			if (!o[this.name].push) {
				o[this.name] = [o[this.name]];
			}
			o[this.name].push(this.value || '');
		} else {
			o[this.name] = this.value || '';
		}
	});
	return o;
};

let parseErrorResponse = (errors, dump) => {

	let messages = [],
		allErrorCodes = errors.details;

	for (let i in allErrorCodes) {
		let code = allErrorCodes[i].name,
			message = dump[code]
		if (message) {
			messages.push({
				key: i,
				value: message
			})
		}
	}

	if (messages.length === 0) {
		let message = dump.GENERIC_ERROR
		if (message) {
			messages.push({
				key: 0,
				value: message
			})
		}
	}
	return messages
}

let parseValErrResp = (errors, dump, GENERIC_ERROR) => {

	let messages = [],
		allErrorCodes = errors.errorData || [];
	for (let allError in allErrorCodes) {

		let code = allErrorCodes[allError].errorCode || allErrorCodes[allError].code,
			message = dump[code];

		if (message) {
			messages.push({
				key: allError,
				value: message
			})
		}
	}

	if (messages.length === 0) {
		let message = dump[GENERIC_ERROR]
		if (message) {
			messages.push({
				key: 0,
				value: message
			})
		}
	}
	return messages
}

let getErrFields = (errors) => {

	let allFields = [],
		allErrorCodes = errors.errorData || [];
	for (let allError in allErrorCodes) {
		allFields.push({
			key: allError,
			type: allErrorCodes[allError].code,
			fields: allErrorCodes[allError].fields
		})
	}

	if (allFields.length === 0) {
		allFields.push({
			key: 0,
			type: 'VALIDATION_ERROR'
		})
	}


	return allFields
}

/**
 * Checks whether minimum donation restriction should be enforced.
 * @return {Boolean} true if currency code is USD
 */
const shouldEnforceMinimumDonation = () => {
	// @TODO: Check for corpIp
	// TemplateData.isCorpIp
	if (templateData.donationAmountEditable && templateData.donationCode === 'USD') {
		return true;
	}
	return false;
}

/**
 * Gets minimum donation for current currency
 * @return {Number} 1 for USD, 0 otherwise
 */
const getMinimumDonation = () => {
	// @TODO: Check for corpIp
	// && !TemplateData.isCorpIp
	if (templateData.donationCode === 'USD') {
		return 1;
	}
	return 0;
}

/**
 * Validates the donation amount restriction for USD
 * @return { Boolean } Returns false if validation fails, true otherwise
 */
const validateDonationAmountForUS = () => {
	if (shouldEnforceMinimumDonation()) {
		const donationAmount = appStore.getDonationAmount() || 0;
		const minimumDonation = getMinimumDonation();
		if (donationAmount < minimumDonation) {
			return false;
		}
	}

	return true;
}

/**
 * Checks whether to show the promotion for HurricaneHarvey or not
 * Please note: Currently disabled. Always returns false.
 */
const shouldShowHurricaneHarveyPromotion = () => {
	return false;
	// Check merchant and user country
	// const userCountry = templateData.country;
	// const userLanguage = templateData.language;

	// return userCountry === 'US' && userLanguage === 'en';
}

/**
 * Sets country and locale in the provided string
 * @param  {String} str         String to set country and locale on
 * @param  {String} country     Country code like 'AU', 'US'
 * @param  {String} locale      locale code like 'en_AU', en_US'
 * @return {String}             Original string with country and locale
 */
const setCountryAndLocale = (str) => {
	str = str.replace(new RegExp('{country}', 'g'), templateData.country);
	str = str.replace(new RegExp('{locale}', 'g'), `${templateData.language}_${templateData.country}`);
	return str;
}

module.exports = {
	addShake: _addShake,
	updateDonation: updateDonation,
	logCalEvent: logCalEvent,
	handleLogIn: handleLogIn,
	handleGuestCountryChange: handleGuestCountryChange,
	handleTokenReuse: handleTokenReuse,
	handleGuest: handleGuest,
	removeErrors: removeErrors,
	serializeFormData: serializeFormData,
	parseErrorResponse: parseErrorResponse,
	parseValErrResp: parseValErrResp,
	getErrFields: getErrFields,
	shouldEnforceMinimumDonation,
	validateDonationAmountForUS,
	shouldShowHurricaneHarveyPromotion,
	setCountryAndLocale
}



// WEBPACK FOOTER //
// ./utility/helper.js